'use client'

import { type Dispatch, type SetStateAction, useState } from 'react'

import {
  type RxByPrincipleReasonSet,
  type RxByPrincipleSelectableReason,
} from '@redteclab/api/clients/bully'

import { useProductApiSwrFetchCartMetadata } from '../api/swr/useProductApiSwrFetchCartMetadata'

export type RxByPrincipleControls =
  | {
      isReasonRequired: boolean
      queryParamName: `rxByPrincipleReason[${string}]`
      reasonSet: RxByPrincipleReasonSet
      selectedReason?: RxByPrincipleSelectableReason
      setSelectedReason: Dispatch<
        SetStateAction<RxByPrincipleSelectableReason | undefined>
      >
    }
  | {
      isReasonRequired: false
    }

export const useRxByPrincipleControls = ({
  rxByPrincipleReasonSet,
  selectedOfferId,
}: {
  rxByPrincipleReasonSet?: RxByPrincipleReasonSet
  selectedOfferId?: string
}): RxByPrincipleControls => {
  const offerId = selectedOfferId
  const reasonSet = rxByPrincipleReasonSet

  const { data } = useProductApiSwrFetchCartMetadata({
    disabled: !offerId || !reasonSet,
  })

  const reasonAlreadyProvided = Boolean(
    offerId &&
    data?.rxByPrinciple?.offerIdsWithAlreadySelectedReasons?.includes(offerId),
  )

  const [selectedReason, setSelectedReason] =
    useState<RxByPrincipleSelectableReason>()

  if (offerId && reasonSet && !reasonAlreadyProvided) {
    return {
      isReasonRequired: true,
      queryParamName: `rxByPrincipleReason[${offerId}]`,
      reasonSet,
      selectedReason,
      setSelectedReason,
    }
  }

  return {
    isReasonRequired: false,
  }
}
